import React from 'react';
import { useIntl } from 'react-intl';
import { TikTokCreatorInfo, tiktokShowsDuetAndStitch } from 'fym-shared/src/music24/tiktokPostSettings';
import { TypedMemo } from '../../../../common/types';
import { SettingsSwitchRow } from '../settings/SettingsSwitchRow';
import { tiktokMessages } from './tiktokMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from '../settings/PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TikTokInteractionFieldsProps {
  creator: TikTokCreatorInfo;
  allowComment: boolean;
  allowDuet: boolean;
  allowStitch: boolean;
  mediaKind: 'image' | 'video' | null;
  onAllowComment: (value: boolean) => void;
  onAllowDuet: (value: boolean) => void;
  onAllowStitch: (value: boolean) => void;
}

/**
 * Comments, Duet and Stitch (TikTok Direct Post G4): off at the start, each one greyed out with
 * a reason when the creator turned it off in TikTok. A photo post has comments only.
 */
const TikTokInteractionFieldsComponent: React.FC<TikTokInteractionFieldsProps> = ({
  creator,
  allowComment,
  allowDuet,
  allowStitch,
  mediaKind,
  onAllowComment,
  onAllowDuet,
  onAllowStitch,
}) => {
  const intl = useIntl();
  const offNote = intl.formatMessage(tiktokMessages.offInTikTok);
  const showVideoOptions = tiktokShowsDuetAndStitch(mediaKind);

  return (
    <div className={styles.field}>
      <span className={styles.eyebrow}>{intl.formatMessage(tiktokMessages.interactionsLabel)}</span>
      <div className={styles.group}>
        <SettingsSwitchRow
          id="tiktok-comment"
          title={intl.formatMessage(tiktokMessages.allowComment)}
          note={creator.commentDisabled ? offNote : undefined}
          checked={allowComment && !creator.commentDisabled}
          disabled={creator.commentDisabled}
          onChange={onAllowComment}
        />
        {showVideoOptions ? (
          <>
            <SettingsSwitchRow
              id="tiktok-duet"
              title={intl.formatMessage(tiktokMessages.allowDuet)}
              note={creator.duetDisabled ? offNote : undefined}
              checked={allowDuet && !creator.duetDisabled}
              disabled={creator.duetDisabled}
              onChange={onAllowDuet}
            />
            <SettingsSwitchRow
              id="tiktok-stitch"
              title={intl.formatMessage(tiktokMessages.allowStitch)}
              note={creator.stitchDisabled ? offNote : undefined}
              checked={allowStitch && !creator.stitchDisabled}
              disabled={creator.stitchDisabled}
              onChange={onAllowStitch}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export const TikTokInteractionFields = TypedMemo(TikTokInteractionFieldsComponent);
